module.exports = __webpack_public_path__ + "img/sh.a4c63612.png";